export default "__VITE_ASSET__D8QA5glT__"